// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + ".mp." + {"FavouritesUiDynamicBuyerInfoModal":"85d3ec2d","SmartBannerFullScreen":"64d551a4"}[chunkId] + ".css";
};